import { createInstance } from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next/initReactI18next'

import { NameSpaces } from '@/types/i18next'

import languages from '../../locales.config'

export const locales = languages.slice(1)

const initI18next = async (lng: string, ns: string) => {
  const i18nInstance = createInstance()
  await i18nInstance
    .use(initReactI18next)
    .use(
      resourcesToBackend(async (language: string, namespace: string) => {
        return import(`./locales/${language}/${namespace}.json`) as Promise<
          Record<string, unknown>
        >
      }),
    )
    .init({
      // debug: true,
      returnObjects: true,
      supportedLngs: languages,
      appendNamespaceToMissingKey: true,
      fallbackLng: 'en-us',
      lng,
      ns,
      lowerCaseLng: true,
    })
  return i18nInstance
}
export async function getTranslations<K extends keyof NameSpaces>(lng: string, ns: K) {
  const i18nextInstance = await initI18next(
    lng,
    (Array.isArray(ns) ? ns[0] : ns) as string,
  )
  return {
    t: i18nextInstance.getFixedT<K>(lng, ns),
    i18n: i18nextInstance,
  }
}

const TranslatedLocalizedCountries: Record<string, string> = {
  SE: 'Sverige',
  HU: 'Magyarország',
  IE: 'Ireland',
  CA: 'Canada',
  RS: 'Srbija',
  PT: 'Portugal',
  NL: 'Nederland',
  IT: 'Italia',
  DK: 'Danmark',
}

const LocalizedCountriesEnglish: Record<string, string> = {
  SE: 'Sweden',
  HU: 'Hungary',
  IE: 'Ireland',
  CA: 'Canada',
  RS: 'Serbia',
  PT: 'Portugal',
  NL: 'Netherlands',
  IT: 'Italy',
  DK: 'Denmark',
}

export const getLocalizedCountryName = (locale: string): string | null => {
  const language = locale.slice(0, 2).toUpperCase()
  const country = locale.slice(3, 5).toUpperCase()
  return (
    (language === 'EN'
      ? LocalizedCountriesEnglish[country]
      : TranslatedLocalizedCountries[country]) ?? null
  )
}

export const localeNames = {
  'sv-se': 'Svenska',
  en: 'English',
  'de-de': 'Deutsch',
  es: 'Español',
  'fr-fr': 'Français',
  'it-it': 'Italiano',
  'hu-hu': 'Magyar',
  'sr-rs': 'Srpski',
  'hr-hr': 'Hrvatski',
  'pl-pl': 'Polski',
  'ro-ro': 'Română',
  'nl-nl': 'Nederlands',
  'sk-sk': 'Slovakian',
  'pt-pt': 'Português',
  'mk-mk': 'македонски',
} as const
